import React, { useCallback } from 'react';
import AsyncSelect from 'react-select/async';
import TargetingClient from '~/state/Targeting/client';

import fb from '~/api/core/facebook';

const invalidTypes = [
  'subcity',
  'neighborhood',
  'metro_area',
  'small_geo_area',
  'medium_geo_area',
  'subneighborhood',
  'electoral_district',
  'zips',
];


const handleValue = (e, { action, ...rest }) => {
  switch (action) {
    case 'select-option': {
      return TargetingClient.cities.add(rest.option);
    }
    case 'pop-value':
    case 'remove-value': {
      if (rest.removedValue === undefined) return null;
      return TargetingClient.cities.remove(rest.removedValue.key);
    }
    case 'clear': {
      return TargetingClient.cities.clear();
    }
    default: {
      return null;
    }
  }
};

const handleLoad = (query) => {
  const cleanQuery = query.trim().toLowerCase();
  const path = `search?q=${cleanQuery}&type=adgeolocation&location_types=['city']`;
  return fb(path, 'GET', null)
    .then((s) => {
      const validSuggestions = s.data.filter(
        suggestion => invalidTypes.indexOf(suggestion.type) === -1,
      );
      return validSuggestions;
    });
};

// z-index to prevent ad type buttons from
// overlaying dropdown
const customCityStyling = {
  container: () => ({
    zIndex: 902,
  }),
};

const CityInput = () => {
  const handleSelect = useCallback((e, data) => handleValue(e, data), [handleValue]);

  return (
    <div className="link__row">
      <div className="link__input-container">
        <div className="collage__header">
          <h4>City</h4>
          <p>Click on a suggestion from the dropdown box to add a city</p>
          <AsyncSelect
            isMulti
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            loadOptions={handleLoad}
            getOptionValue={e => e.key}
            getOptionLabel={e => `${e.name}, ${e.region}, ${e.country_code}`}
            onChange={handleSelect}
            name="Cities"
            placeholder="Choose cities..."
            styles={customCityStyling}
          />
        </div>
      </div>
    </div>
  );
};

export default CityInput;
